import React from "react";

const DataScienceOutline = props => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <g fillRule="evenodd">
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        d="M5 19a1 1 0 001 1h12a1 1 0 00.82-1.57L13 8.35V4h-2v4.35L5.18 18.43c-.11.16-.18.36-.18.57zm1 3a3 3 0 01-3-3c0-.6.18-1.16.5-1.63L9 7.81V6a1 1 0 01-1-1V4a2 2 0 012-2h4a2 2 0 012 2v1a1 1 0 01-1 1v1.81l5.5 9.56c.32.47.5 1.03.5 1.63a3 3 0 01-3 3H6z"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default DataScienceOutline;
